<template>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px"  lazy persistant @keyup.enter="save" @keydown.esc="close">
         <component v-if="dialogCustomComponent" :is="dialogMainComponent"></component>
         <component v-else :is="component.component" :props="component.props">
       </component>
      </v-dialog>
    </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  props: ['component'],
  methods: {
    save (event) {
      event.stopPropagation()
      if (this.component.save) {
        this.component.save(event, this)
      }
      this.dialog = false
    },
    close () {
      event.stopPropagation()
      if (this.component.close) {
        this.component.close(event, this)
      }
      this.dialog = false
    }
  },
  computed: {
    dialog: sync('dialogOpen'),
    dialogCustomComponent: sync('dialogCustomComponent'),
    dialogMainComponent: sync('dialogMainComponent')
  }
}
</script>

<style>

</style>
